
import React, { useEffect, useState } from "react";
import _ from "lodash";
import RCInput, { extractFromRC } from "../../forms/RCInput";
import PropTypes from "prop-types";

/**
 * Edit RCInput cell component
 * @module
 * @param {func} onChange - Function invoked on change
 * @param {string} dataItem - Data item
 * @param {string} field - Field
 * @param {string} className - TD Class name
 * @param {number} colSpan - Number of columns which cell expands to
 * @param {object} style - Style
 * @param {number} columnIndex - Column index
 * @param {number} level - Level
 * @param {func} render - Render function
 */
export const editRCInputCell = ({ isValueChanged }) => {
  const EditRCInputCell = (props) => {
    let timeout = null;

    const { onChange, dataItem, field, tdProps, isInEdit } = props;
    const [value, setValue] = useState(_.get(dataItem, field.split(".")));

    const handleInputChange = (name, value) => {
      setValue(value);

      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }

      timeout = setTimeout(() => {
        onChange({
          dataItem: dataItem,
          field: field,
          syntheticEvent: new Event("change"),
          value: value,
        });

        timeout = null;
      }, 1000);
    };

    const getString = (dataValue) => {
      if (!dataValue) return "";
      if (dataValue?.includes("/")) return dataValue;
      return `${dataValue.substr(0, 6)}/${extractFromRC(dataValue, "SSSC")}`;
    }

    useEffect(() => {
      setValue(_.get(dataItem, field.split(".")));
    }, [dataItem, field]);

    const buildInput = (dataValue) => {
      return <RCInput
        type="sk"
        onChange={handleInputChange}
        value={dataValue}
        name={field}
        validationHidden={true}
      />
    };

    return <td
      {...tdProps}
      className={`${tdProps.className} ${isValueChanged && isValueChanged(dataItem, field) ? "k-state-changed" : ""}`}
      tabIndex={0}
    >
      {isInEdit ? buildInput(value) : getString(value)}
    </td>
  };

  EditRCInputCell.propTypes = {
    onChange: PropTypes.func,
    dataItem: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    field: PropTypes.string,
    className: PropTypes.string,
    colSpan: PropTypes.number,
    style: PropTypes.object,
    columnIndex: PropTypes.number,
    level: PropTypes.number,
    render: PropTypes.func,
  };

  return EditRCInputCell;
};
